import { generateRegistrationID } from '@/utils/helper'

export default {
  setOppRegistration (state, data) {
    // set opportunity state
   state.workloadForm.oppFields.opportunity = {
      Opportunity_Id: data.opportunity.opportunity_id, 
      SFDC_Oppty_Name: data.opportunity.opportunity_name,
      SFDC_Sales_Stage: data.opportunity.SFDC_Sales_Stage,
      SignDate: data.opportunity.SignDate,
      OpportunityTotalValueUSD: data.opportunity.OpportunityTotalValueUSD,
      ESRegion: data.opportunity.es_region,
      Customer_Name: data.opportunity.customer_name,
      Country: data.opportunity.country,
      PrimaryESPracticeName: data.opportunity.PrimaryESPracticeName,
      OpportunityDescription: data.opportunity.OpportunityDescription,
      OpportunityStatus: data.opportunity.OpportunityStatus,
      IndustryVertical: data.opportunity.IndustryVertical,
      ContractLength: data.opportunity.ContractLength,
      Client_ID: data.opportunity.client_id,
      Owner_Email: data.opportunity.owner_email,
      Owner_Name: data.opportunity.owner_name
    }

    let d = new Date(data.opportunity.SignDate)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    let year = d.getFullYear()
    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day
    let finalSignDate = [year, month, day].join('-')
    // Formatted Sign Date
    state.workloadForm.oppFields.opportunity.SignDate = finalSignDate

    // set default account state from SF
    if(data.opportunity.customer_name !== ''){
      state.isCustName = true
    } else {
      state.isCustName = false
    }

    state.workloadForm.oppFields.account = {
      ...state.workloadForm.oppFields.account,
      // new: 
      Client_ID: data.opportunity.client_id,
      Customer_Name: data.opportunity.customer_name,
      Customer_Region: data.opportunity.es_region,
      Customer_URL: data.opportunity.customer_url,
      Customer_Address: data.opportunity.customer_address,
      Customer_City: data.opportunity.customer_city,
      Customer_State:data.opportunity.customer_state,
      Customer_PC: data.opportunity.customer_postal_code,


    }

    state.workloadForm.fields.Campaign_Name = data.opportunity.campaign_name ? data.opportunity.campaign_name : ''
    state.workloadForm.fields.Scope_of_Work = Number(data.opportunity.Scope_of_Work)
  },

  setShowOppForm (state, data) {
    state.showOppForm = data
  },
  setOppregStep (state, step) {
    state.oppregStep = step
  },
  setSfdcId (state, id) {
    state.sfdcId = id
    state.workloadForm.validatedSfdcId = id
  },
  setOppType(state, oppType) {
    state.oppType = oppType
    state.workloadForm.oppType =  oppType

    if(oppType === 'internal'){
      state.oppForm = {
        ...state.oppForm, 
        label: {
          Customer_Name: 'Internal Name',
          Customer_Street: 'Internal Street', 
          Customer_City: 'Internal City',
          Customer_Url: 'Internal URL'
        },
        placeholder: {
          Customer_Name: 'Internal Name',
          Customer_Street: 'Internal Street',
          Customer_City: 'Internal City', 
          Customer_Url: 'Internal URL'
        }
      } 
    } 
    if(oppType === 'subsidiary'){
      state.oppForm = {
        ...state.oppForm, 
        label: {
          Customer_Name: 'Subsidiary Name',
          Customer_Street: 'Subsidiary Street', 
          Customer_City: 'Subsidiary City',
          Customer_Url: 'Subsidiary URL'
        },
        placeholder: {
          Customer_Name: 'Subisidiary Name',
          Customer_Street: 'Subsidiary Street',
          Customer_City: 'Subsidiary City', 
          Customer_Url: 'Subsidiary URL'
        }

        
      } 
    }
      if(oppType === 'gainwell'){
      state.oppForm = {
        ...state.oppForm, 
        label: {
          Customer_Name: 'Gainwell Customer Name',
          Customer_Street: 'Customer Street No.', 
          Customer_City: 'Customer City',
          Customer_Url: 'Customer URL'
        },
        placeholder: {
          Customer_Name: 'Gainwell Customer Name',
          Customer_Street: 'Customer Street No.',
          Customer_City: 'Customer City', 
          Customer_Url: 'Customer URL'
        }

        
      } 
    }
  },
  setOpportunityId (state, id) {  
    // state.opportunityRecord.opportunity.Opportunity_Id = id
    // new 
    state.workloadForm.oppFields.opportunity.Opportunity_Id = id
  },
  setCustomId (state, flag) {
    state.customId = flag
  },
  setShowOppWorkload (state, data) {
    state.showOppWorkload = data
  },
  // setContactId (state, data) {
  //   state.oppregistration.workload.Contact_Id = data
  // },
  setRegisteringOpp (state, data) {
    state.registering = data
  },
  validatingOppId (state, loading) {
    state.validatingOppId = loading
  },
  setValidatedOpp (state, validated) {
    state.oppIdValidated = validated
  },
  setSubmittingOppForm (state, data) {
    console.log('form submitting: '+ state.formSubmitting)
  },
  setSubmittingOpp (state, data) {
    state.submitting = data
  },
  setIsSubmitted (state, data) {
    state.isSubmitted = data
  },
  resetRegistration (state) {
    state.sfdcId = ''
    state.oppregStep = 'verification'
    state.oppType = ''
    state.oppForm = {
      label:{
        Customer_Name: 'Customer Name',
        Customer_Street: 'Customer Street', 
        Customer_City: 'Customer City',
        Customer_Url: 'Customer URL'
      },
      placeholder: {
        Customer_Name: 'Customer Name',
        Customer_Street: 'Customer Street', 
        Customer_City: 'Customer City',
        Customer_Url: 'Customer URL'
      }
    }

  },
  clearOpportunityRecord (state) {
    state.opportunityRecord = {
      opportunity: {
        Opportunity_Id: null,
        SFDC_Oppty_Name: null,
        SFDC_Sales_Stage: null,
        SignDate: null,
        OpportunityTotalValueUSD: null,
        ESRegion: null,
        Customer_Name: null,
        Country: null,
        PrimaryESPracticeName: null,
        OpportunityDescription: null,
        OpportunityStatus: null,
        IndustryVertical: null,
        IndustryVerticalOther: null,
        NatSec: null,
        Global_Registered: null,
        ContractLength: null,
        Opportunity_Number: null,
        Client_ID: null,
        Owner_Email: null,
        Owner_Name: null
      },
      account: {
        Client_ID: null,
        Customer_Id: null,
        Customer_URL: null,
        Customer_Address: null,
        Customer_City: null,
        Customer_State: null,
        Customer_PC: null,
        Industry: null
      },
      requestor: {
        Requestor_Id: null,
        Requestor_First_Name: null,
        Requestor_Last_Name: null,
        Requestor_Phone: null,
        Requestor_Email: null
      },
      contact: {
        Contact_Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null
      },
      header: {
        Oppreg_Header_Notes: null,
        Client_ID: null,
        RFI_RFP: null
      }
    }
  },
  setWorkloadStep (state, step) {
    state.workloadStep = step
  },
  setWorkloadType (state, type) {
    state.workloadForm.fields.Workload_type = type
  },
  clearOpportunityRecord(state, data){
    state.workloadForm.oppFields.opportunity = {
      Client_ID: null,
      ContractLength: null,
      Country: null,
      Customer_Name: null,
      ESRegion: null,
      IndustryVertical: null,
      IndustryVerticalOther: null,
      NatSec: null,
      Global_Registered: null,
      OpportunityDescription: null,
      Opportunity_Number: null,
      OpportunityStatus: null,
      OpportunityTotalValueUSD: null,
      Opportunity_Id: null,
      PrimaryESPracticeName: null,
      SFDC_Oppty_Name: null,
      SFDC_Sales_Stage: null,
      SignDate: null
    }

  },
  clearWorkloadForm (state, data) {
    state.customId =  false, 
    state.isCustName = false,
    state.workloadForm = {
      validatedSfdcId: '',
      oppType:'',
      submitting: false, // this state is also being used for the update loading
      enteringNew: false,
      savingForLater: false,
      registrationIdValidation: {
        validated: false,
        loading: false,
        success: false,
        successMessage: '',
        error: false,
        errorMessage: ''
      },
      loadingContact: false,
      sameAsLoggedInUser: false,
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Email: null,
        Contact_Title: null
      },
      fields: {
        Project_Id: null,
        OppReg_Id: null,
        Registration_Id: null,
        Contact_Id: null,
        Requestor_Id: null,
        SFDC_Id: null,
        Workload_Title: null,
        Campaign_Name: null,
        Solution_Business_Segment: null,
        Scope_of_Work: null,
        Is_Glacier: null,
        VMware_Workload: null,
        VMware_License: null,
        VMware_Cust_Deploy: null,
        Workload_type: 'N/A',
        Workload_Type_Date_Change: null,
        PPA_Attestation: null,
        Root_Access: null,
        DXC_Managed_Services: null,
        SaaS: null,
        Initiate_Account_Flag: null,
        Workload_Services_Storage: null,
        Workload_Services_Database: null,
        Workload_Services_App_services: null,
        Workload_Services_Compute: null,
        Workload_Services_Network: null,
        Projected_Monthly_Spend: 0,
        WL_Overall_Objective: null,
        WL_Scope_Bounderies: null,
        WL_App_Transformed: null,
        WL_Next_Pursuit: null,
        OppReg_Project_Notes: null,
        OppReg_Req_Date: null,
        Workload_Status: null,
        P_Offering_Agreed: 'Y',
        // answers table
        WL_Q1A: null,
        WL_Q2A: null,
        WL_Q3A: null,
        WL_Q4A: null,
        WL_Q5A: null,
        WL_Q6A: null,
        Attested_By: null,
        DXC_Services: null,
        DXC_SA1: null,
        DXC_SA2: null,
        WL_Q7A: '[]',
        WL_Q8A: null,
        WL_Q9A: null,
        WL_Q10A: null,
        Q1: null,
        Q2: null,
        Q3: null,
        Q4: null,
        Q5: null,
        Q6: null,
        Q7: null,
        Q8: null,
        Q9: null,
        Q10: null,
        Attested_By_Date: null,
        Attested_By_Email: null,
        Attested_By_Title: null,
        Attested_By_Manager: null,
        Attested_By_Date_2: null,
        Attested_By_Email_2: null,
        Attested_By_Title_2: null,
        Attested_By_Manager_2: null,
        // Discount_Tier_On_AWS: null,
        Discount_Tier_On_AWS: null,
        Discount_Tier_On_AWS_2: null,
        Pricing_Tier_Qualification: null,
        Pricing_Tier_Qualification_2: null
      },

      oppFields: {
        opportunity: {
          Opportunity_Id: null,
          SFDC_Oppty_Name: null,
          SFDC_Sales_Stage: null,
          SignDate: null,
          OpportunityTotalValueUSD: null,
          ESRegion: null,
          Customer_Name: null,
          Country: null,
          PrimaryESPracticeName: null,
          OpportunityDescription: null,
          OpportunityStatus: null,
          IndustryVertical: null,
          IndustryVerticalOther: null,
          NatSec: null,
          Global_Registered: null,
          ContractLength: null,
          Opportunity_Number: null,
          Client_ID: null
        },
        account: {
          Client_ID: null,
          Customer_Id: null,
          Customer_Name: null,
          Customer_Region: null,
          Customer_URL: null,
          Customer_Address: null,
          Customer_City: null,
          Customer_State: null,
          Customer_PC: null,
          Industry: null
        },
        requestor: {
          Requestor_Id: null,
          Requestor_First_Name: null,
          Requestor_Last_Name: null,
          Requestor_Phone: null,
          Requestor_Email: null
        },
        contact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Phone: null,
          Contact_Email: null,
          Contact_Title: null
        },
        header: {
          Oppreg_Header_Notes: null,
          Client_ID: null,
          RFI_RFP: null
        }
      }

    }
  },
  setSelectedAwsServices (state, services) {
    state.workloadForm.fields.WL_Q7A = JSON.stringify(services)
  },
  clearAwsServicesCustomRegion (state) {
    state.workloadForm.fields.WL_Q9A = ''
  },
  setWorkloadSubmitting (state, data) {
    state.workloadForm.submitting = true
  },
  setNotification (state, data) {
    state.newOppRegistration.withError = data
  },
  setWorkloadStatus (state, status) {
    state.workloadForm.fields = {
      ...state.workloadForm.fields,
      Workload_Status: status,
      OppReg_Req_Date: status === 'Submitted by User' ? window.moment().format('YYYY-MM-DD') : null
    }
  },
  // setWorkloadContact (state, contact) {
  //   state.workloadForm.contact = { ...contact }
  // },
  setRecordNotFound (state, data) {
    state.recordNotFound = data
  },
  setRequestor (state, user) {
    // state.opportunityRecord.requestor.Requestor_Id = user.requestor_id
    // state.opportunityRecord.requestor.Requestor_Last_Name = user.family_name
    // state.opportunityRecord.requestor.Requestor_First_Name = user.given_name
    // state.opportunityRecord.requestor.Requestor_Email = user.email
    // state.opportunityRecord.requestor.Requestor_Phone = user.phone_number

    state.workloadForm.oppFields.requestor.Requestor_Id = user.requestor_id
    state.workloadForm.oppFields.requestor.Requestor_Last_Name = user.family_name
    state.workloadForm.oppFields.requestor.Requestor_First_Name = user.given_name
    state.workloadForm.oppFields.requestor.Requestor_Email = user.email
    state.workloadForm.oppFields.requestor.Requestor_Phone = user.phone_number
  },
  setContact (state, user) {
    // state.opportunityRecord.contact.Contact_Id = user.contact_id
    // state.opportunityRecord.contact.Contact_Last_Name = user.family_name
    // state.opportunityRecord.contact.Contact_First_Name = user.given_name
    // state.opportunityRecord.contact.Contact_Email = user.email
    // state.opportunityRecord.contact.Contact_Phone = user.phone_number

    state.workloadForm.oppFields.contact.Contact_Id = user.contact_id
    state.workloadForm.oppFields.contact.Contact_Last_Name = user.family_name
    state.workloadForm.oppFields.contact.Contact_First_Name = user.given_name
    state.workloadForm.oppFields.contact.Contact_Email = user.email
    state.workloadForm.oppFields.contact.Contact_Phone = user.phone_number
  },
  clearContact (state) {
    // state.opportunityRecord.contact.Contact_Last_Name = null
    // state.opportunityRecord.contact.Contact_First_Name = null
    // state.opportunityRecord.contact.Contact_Email = null
    // state.opportunityRecord.contact.Contact_Phone = null

    state.workloadForm.oppFields.contact.Contact_Last_Name = null
    state.workloadForm.oppFields.contact.Contact_First_Name = null
    state.workloadForm.oppFields.contact.Contact_Email = null
    state.workloadForm.oppFields.contact.Contact_Phone = null
  },
  setWorkloadContact (state, user) {
    state.workloadForm.contact = {
      Contact_Id: user.Id,
      Contact_Last_Name: user.Contact_Last_Name,
      Contact_First_Name: user.Contact_First_Name,
      Contact_Email: user.Contact_Email,
      Contact_Phone: user.Contact_Phone
    }
    state.workloadForm.fields.Contact_Id = user.Id
  },
  clearWorkloadContact (state) {
    state.workloadForm.contact = {
      Contact_Id: null,
      Contact_Last_Name: null,
      Contact_First_Name: null,
      Contact_Email: null,
      Contact_Phone: null
    }
    state.workloadForm.fields.Contact_Id = null
  },
  setLoadingContact (state, loading) {
    state.workloadForm.loadingContact = loading
  },
  setRegistrationID (state, id) {
    state.workloadForm.fields.Registration_Id = id
  },
  setCustomAccountName (state, name) {
    // state.opportunityRecord.account.Customer_Name = name
    state.workloadForm.oppFields.account.Customer_Name = name
  },
  // setSelectedAwsServices (state, selectedAwsServices) {
  //   state.workloadForm.fields.Workload_Services_Storage = selectedAwsServices.includes('Storage') ? '1' : '0'
  //   state.workloadForm.fields.Workload_Services_Database = selectedAwsServices.includes('Database') ? '1' : '0'
  //   state.workloadForm.fields.Workload_Services_App_services = selectedAwsServices.includes('App Services') ? '1' : '0'
  //   state.workloadForm.fields.Workload_Services_Compute = selectedAwsServices.includes('Compute') ? '1' : '0'
  //   state.workloadForm.fields.Workload_Services_Network = selectedAwsServices.includes('Network') ? '1' : '0'
  // },
  // newOppRegistration
  showWorkloadSearching (state, data) {
    state.newOppRegistration = { ...state.newOppRegistration, ...data }
  },
  resetNewOppRegistration (state) {
    state.newOppRegistration = {
      searching: false,
      opportunityFound: false,
      type: 'new'
    }
    state.workloadList = []
  },
  setWorkloadData (state, workload) {
    let workloadFields = {}
    let oppFields = {}
    let oppAccountFields = {}

    for (const fieldName in state.workloadForm.fields) {
      if (workload.hasOwnProperty(fieldName)) {
        workloadFields[fieldName] = workload[fieldName]
      }
    }
    state.workloadForm.fields = {
      ...state.workloadForm.fields, ...workloadFields
    }

    for (const fieldName in state.workloadForm.oppFields.opportunity) {
      if (workload.hasOwnProperty(fieldName)) {
        oppFields[fieldName] = workload[fieldName]
      }
    }
    for (const fieldName in state.workloadForm.oppFields.account) {
      if (workload.hasOwnProperty(fieldName)) {
        oppAccountFields[fieldName] = workload[fieldName]
      }
    }

    state.workloadForm.oppFields.opportunity = oppFields
    state.workloadForm.oppFields.account = oppAccountFields

  },
  setWorkloadLoading (state, data) {
    state.workloadForm = { ...state.workloadForm, ...data }
  },

  setWorkloadDataList (state, workloads) {
    state.workloadList = workloads
    // state.newOppRegistration = { ...state.newOppRegistration, ...data }
  },

  // setOpportunityFound (state, id) {
  //   state.newOppRegistration = { ...state.newOppRegistration, opportunityFound: true, opportunityId: id }
  // },

  showNewWorkload (state, OpportunityID) {
    state.workloadForm.fields.SFDC_Id = state.workloadForm.fields.OppReg_Id = OpportunityID
    state.workloadForm.fields.Requestor_Id = vm.$store.state.currentUser.requestor_id
    state.oppregStep = 'workload'
    state.newOppRegistration = {
      ...state.newOppRegistration,
      type: 'new'
    }
  },

  // hideWorkload (state) {
  //   state.newOppRegistration = {
  //     ...state.newOppRegistration,
  //     showWorkloadForm: false
  //   }
  // },

  showEditWorkload (state, opportunityId) {
    state.workloadForm.fields.SFDC_Id = state.workloadForm.fields.OppReg_Id = opportunityId
    state.oppregStep = 'workload'
    state.newOppRegistration = {
      ...state.newOppRegistration,
      type: 'edit'
    }
  },

  showUpdateDiscountWorkload (state, opportunityId) {
    state.workloadForm.fields.SFDC_Id = state.workloadForm.fields.OppReg_Id = opportunityId
    state.oppregStep = 'workload'
    state.newOppRegistration = {
      ...state.newOppRegistration,
      type: 'update-discount'
    }
  },

  // updateDiscountInformation(state, discount) {
  //   state.workloadForm.fields = {
  //     ...state.workloadForm.fields,
  //     ...discount
  //   }
  // },

  setDiscountId(state, id) {
    state.updateDiscount.registrationId = id
  },

  updatingDiscount(state, loading) {
    state.updateDiscount.saving = loading
  },

  showUpdateDiscountSuccess(state, visibility) {
    state.updateDiscount.success = visibility
  },

  resetUpdateDiscountPage(state) {
    state.updateDiscount = {
      ...state.updateDiscount,
      opportunityId: null,
      list: [],
      showDiscountPage: false,
      searching: false,
      registrationId: null,
      saving: false,
      accountRecordFound: false
    }
  },

  searchingDiscountRecord(state, searching) {
    state.updateDiscount.searching = searching
  },

  setDiscountPageListData(state, data) {
    state.updateDiscount.list = data
  },

  showDiscountPage(state, visibility) {
    state.updateDiscount.showDiscountPage = visibility
  },

  setDiscountPage(state, data) {
    state.updateDiscount = {
      ...state.updateDiscount,
      ...data
    }
  },

  setAccountRecordFound(state, isFound) {
    state.updateDiscount.accountRecordFound = isFound
  },

  showWorkload (state, OpportunityID) {
    state.workloadForm.fields.SFDC_Id = state.workloadForm.fields.OppReg_Id = OpportunityID
    state.workloadForm.fields.Requestor_Id = vm.$store.state.currentUser.requestor_id
    state.oppregStep = 'viewOppForm'
    state.newOppRegistration = {
      ...state.newOppRegistration,
      type: 'view'
    }
  },

  setRegistrationIdValidation (state, data) {
    state.workloadForm = {
      ...state.workloadForm,
      registrationIdValidation: { ...data }
    }
  },

  insertWorkloadListRecord (state, workload) {
    state.workloadList.push(workload)
  },

  updateWorkloadListRecord (state, workload) {
    let recordToBeUpdatedIndex = state.workloadList.findIndex(record => record.Registration_Id === workload.Registration_Id)
    if (recordToBeUpdatedIndex !== -1) {
      state.workloadList.splice(recordToBeUpdatedIndex, 1, { ...state.workloadList[recordToBeUpdatedIndex], ...workload })
    }
  },

  updateSubmittedWorkloadList (state, workloadIds) {
    workloadIds.forEach(id => {
      let recordToBeUpdatedIndex = state.workloadList.findIndex(record => record.Project_Id === id)
      if (recordToBeUpdatedIndex !== -1) {
        state.workloadList.splice(recordToBeUpdatedIndex, 1, { ...state.workloadList[recordToBeUpdatedIndex], Workload_Status: 'Submitted by User' })
      }
    })
  },
  resetForm (state) {
    state.showOppForm = true
    state.showOppWorkload = false
  },

  toggleManualRegOption (state, show) {
    state.edlConnectionTimeout = show
  },

  setManualRegistration (state, id) {
    console.log('setting manual registration')
    state.workloadForm.oppFields.opportunity.Opportunity_Id = id
    state.workloadForm.oppFields.opportunity.Client_ID = id
    state.workloadForm.oppFields.account.Client_ID = id
    state.manualRegistration = true
  },

  removeManualRegistration (state) {
    state.manualRegistration = false
  },

  clearDiscountAnswers (state) {
    console.log('clearing answers')
    state.workloadForm.fields = {
      ...state.workloadForm.fields,
      Q8: null,
      Q9: null,
      Q10: null,
      // Discount_Tier_On_AWS: null,
      Pricing_Tier_Qualification: null,
      Attested_By_Date: null,
      Attested_By_Email: null,
      Attested_By_Title: null,
      Attested_By_Manager: null
    }
  },
  setNextWorkloadData (state, nextPageKey) {
    state.nextPageKey = nextPageKey
  },
  setListWorkload (state, data) {
    if (state.nextPageKey) {
      state.listWorkload = [
        ...state.listWorkload,
        ...data
      ]
    } else {
      state.listWorkload = data
    }
    console.log()
  },
  clearNextData (state) {
    state.nextPaginationKey = null
  },
  clearWorkload (state) {
    state.listWorkload = []
  },
  setLoadingWorkloadData (state, set) {
    state.loadingWorkloadData = set
  },
}
